export default __webpack_public_path__ + "static/media/preice-new-2.f48bb78f.png";